/* eslint-disable react/function-component-definition */
/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-props-no-spreading */
import React, { ButtonHTMLAttributes, ReactElement } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  type?: 'submit' | 'reset' | 'button' | undefined;
  disabled?: boolean;
  load?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  type,
  children,
  disabled,
  load,
  ...rest
}): ReactElement => (
  <button
    type={type}
    {...rest}
    disabled={disabled || load}
  >
    {load ? (
      <>
        <span
          className="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        />
        &nbsp;
      </>
    ) : null}

    {children}
  </button>
);

Button.defaultProps = {
  type: 'button',
  load: undefined,
  disabled: undefined,
};

export default Button;
